module.exports = __webpack_public_path__ + "static/git-commits2-94c396b1d3871445a4f5eeec692cd05d.png";